import { useEffect } from 'react';
import { generateShuffleOrder } from '../../utils/shuffleUtils';
import { useMusicState } from '../storeHooks/useMusicState';

export const useShuffleOrder = () => {
  const { activePlaylist, shuffleEnabled, shuffleOrder, setShuffleOrder } =
    useMusicState();

  // Generate shuffle order only when shuffle is toggled or playlist changes
  useEffect(() => {
    if (activePlaylist && shuffleEnabled) {
      // Only generate new shuffle order if:
      // 1. No shuffle order exists, OR
      // 2. Shuffle order length doesn't match track count (playlist changed)
      // DO NOT regenerate when currentIndex changes (track navigation)
      if (
        shuffleOrder.length === 0 ||
        shuffleOrder.length !== activePlaylist.album.tracks.length
      ) {
        const newShuffleOrder = generateShuffleOrder(
          activePlaylist.album.tracks.length,
          activePlaylist.currentIndex,
          activePlaylist.album.tracks, // Pass tracks to filter out unavailable ones
        );
        setShuffleOrder(newShuffleOrder);
      }
    } else if (!shuffleEnabled) {
      // Clear shuffle order when shuffle is disabled
      setShuffleOrder([]);
    }
  }, [
    activePlaylist?.album.id,
    activePlaylist?.album.tracks.length,
    shuffleEnabled,
    shuffleOrder.length, // Only depend on length to avoid infinite loops
  ]);
};
